<a href="#main-content" class="ftg-skip-link">Saltar al contenido</a>

<mat-sidenav-container class="h-full bg-page">
  <mat-sidenav
    [class]="
      'border-r-0 bg-surface transition-[width] duration-[300ms] ease-ftg ' +
      (collapsed() ? '!w-18' : '!w-70')
    "
    [mode]="isMobile() ? 'over' : 'side'"
    [opened]="isMobile() ? sidenavOpened() : true"
    (openedChange)="onOpenedChange($event)"
    [fixedInViewport]="true"
  >
    <app-sidebar
      [collapsed]="!isMobile() && collapsed()"
      (collapsedChange)="setCollapsed($event)"
      [isMobile]="isMobile()"
      (closeRequested)="sidenavOpened.set(false)"
    />
  </mat-sidenav>

  <mat-sidenav-content class="flex flex-col bg-page">
    <app-header (menuToggle)="toggleSidenav()" />
    <main id="main-content" class="min-h-0 flex-1 overflow-y-auto" tabindex="-1">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
